import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className={`navigation-container1 ${props.rootClassName} `}>
      <nav
        id="main-navigation"
        className="navigation-thq-navigation-wrapper-elm navigation-wrapper"
      >
        <div className="navigation-thq-navigation-container-elm navigation-container">
          <div className="navigation-container2">
            <Link to="/" className="navigation-navlink1">
              <img
                alt={props.imageAlt8}
                src={props.imageSrc8}
                className="navigation-image1"
              />
            </Link>
            <Link to="/" className="navigation-navlink2">
              <img
                alt={props.imageAlt10}
                src={props.imageSrc10}
                className="navigation-image2"
              />
            </Link>
          </div>
          <div className="navigation-container3">
            <Link to="/contact" className="navigation-navlink3 button">
              <span className="navigation-text1">
                {props.button ?? (
                  <Fragment className="navigation-fragment2">
                    <span className="navigation-text6">Contact Us</span>
                  </Fragment>
                )}
              </span>
            </Link>
            <Link to="/pricing" className="navigation-navlink4 button">
              <span className="navigation-thq-text-elm">
                {props.button1 ?? (
                  <Fragment>
                    <span className="navigation-text5">Pricing</span>
                  </Fragment>
                )}
              </span>
            </Link>
          </div>
        </div>
      </nav>
      <div
        id="mobile-overlay"
        aria-hidden="true"
        className="navigation-thq-navigation-mobile-overlay-elm navigation-mobile-overlay"
      >
        <div className="navigation-overlay-header">
          <button
            id="mobile-close"
            aria-label="Close Menu"
            className="navigation-close-btn navigation-thq-navigation-close-btn-elm"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6L6 18M6 6l12 12"></path>
              </g>
            </svg>
          </button>
          <Link to="/">
            <img
              alt={props.imageAlt6}
              src={props.imageSrc6}
              className="navigation-image3"
            />
          </Link>
        </div>
        <div className="navigation-thq-navigation-overlay-content-elm navigation-overlay-content">
          <ul className="navigation-thq-navigation-mobile-links-elm navigation-mobile-links">
            <Link to="/">
              <li className="navigation-li1">
                <div className="navigation-mobile-link">
                  <span>Home</span>
                </div>
              </li>
            </Link>
            <Link to="/contact">
              <li className="navigation-li2">
                <div className="navigation-mobile-link">
                  <span>Contact</span>
                </div>
              </li>
            </Link>
            <li className="navigation-li3">
              <div className="navigation-mobile-link">
                <span>Pricing</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

Navigation.defaultProps = {
  imageAlt10: 'image',
  button1: undefined,
  imageAlt8: 'image',
  rootClassName: '',
  imageSrc10: '/bear_flag36-200w.png',
  imageAlt6: 'image',
  imageSrc8: '/bear_flag35-200h.png',
  button: undefined,
  imageSrc6: '/bear_flag3-1500w.png',
}

Navigation.propTypes = {
  imageAlt10: PropTypes.string,
  button1: PropTypes.element,
  imageAlt8: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc10: PropTypes.string,
  imageAlt6: PropTypes.string,
  imageSrc8: PropTypes.string,
  button: PropTypes.element,
  imageSrc6: PropTypes.string,
}

export default Navigation
